(function () {
    angular.module('tmx-app').directive('tmxLoanInput', [tmxLoanByIdInput]);

    function tmxLoanByIdInput() {
        var directive = {
            restrict: 'E'
        };
        directive.controller = ["$scope", "$mdDialog", "$state", "LoanApplicationService", "tmxUtility","tmxResource", tmxLoanByIdInputCtrl];
        directive.controllerAs = "tmxLoanByIdInputCtrl";
        directive.scope = {
            value: "=",
            visibleValue: "=",
            label: "@",
            name: "@",
            user: "=",
            filter: "@",
            form: "=",
            action: "=",
            readonly: '@',
            disabled: '=',
        };
        directive.templateUrl = "common/directives/tmxloanbyidinput/tmxloanbyidinput.html";
        return directive;
    }

    function tmxLoanByIdInputCtrl($scope, $mdDialog, $state, LoanApplicationService, tmxUtility,tmxResource) {
        var vm = this;
        vm.scope = $scope;
        var exists = tmxUtility.exists;

        if (exists($scope.value))
            selectItem($scope.value);

        function selectItem(value) {
            $scope.selectedItem = {};
            $scope.selectedItem.LoanApplicationId = value;
            if (value) {
                tmxResource("LoanApplication").getByAction('?filter=LoanApplicationId~eq~' + value).then(function (loanApp) {
                    $scope.selectedItem.LoanApplicationNumber = loanApp.Data[0].LoanApplicationNumber;
                });
            }
        }

        /*
        if(exists($scope.value))
            selectItem($scope.value);
         */

        vm.loanByIdGridDialog = function (ev) {
            if (vm.scope.readonly) {
                return;
            }
            $mdDialog.show({
                locals: { selectedItem: angular.copy($scope.value), user: $scope.user, action: $scope.action, filter: $scope.filter },
                controller: ["$scope", "$mdDialog", "$state", 'LoanApplicationService', 'selectedItem', 'user', 'action', 'tmxUtility', 'filter','tmxResource', DialogController],
                controllerAs: 'dialogCtrl',
                template: '<md-dialog ng-cloak flex="80"><form><md-dialog-content><kendo-grid id="grid" class="popUpGrid" options="dialogCtrl.mainGridOptions"></kendo-grid>    </md-dialog-content>    <md-dialog-actions layout="row">      <!--md-button class="primary-button" ng-click="hide()">       Filter      </md-button-->    </md-dialog-actions>  </form></md-dialog>',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            })
                .then(function (dataItem) {
                    $scope.selectedItem = dataItem;
                    $scope.value = dataItem.LoanApplicationId;
                });
        };

        function value() {
            return $scope.value;
        }
        /*  function change(newValue,oldValue){
              if( (exists(newValue) || exists(oldValue)) && newValue != oldValue){
                  selectItem(newValue);
              }
          }*/
        // $scope.$watch(value,change);
    }

    function DialogController($scope, $mdDialog, $state, LoanApplicationService, selectedItem, user, action, tmxUtility, filter,tmxResource) {
        var vm = this;
        vm.service = tmxResource("LoanApplication");
        // vm.gridData = new kendo.data.ObservableArray(value);
        var dateFormat=tmxUtility.formatDateForCompany;

        vm.date = new Date().toJSON();
        //vm.cols = LoanApplicationService.filterColumn;
        //vm.nav = "SearchSideNav";
        //vm.schema = LoanApplicationService.schema;
        // vm.cloneColumn = LoanApplicationService.gridColumn;
        //vm.LoanApplicationService = LoanApplicationService;


        //*************Functions****************
        vm.reload = function () {
            vm.container.companyGrid.dataSource.read();
        };

        vm.success = function (promise) {
            if (promise.read == true) {
                vm.container.companyGrid.dataSource.transport.read(promise);
            }
            else {
                vm.container.companyGrid.dataSource.read();
            }
            vm.toggle(vm.nav);
        };
        vm.isFiltered = function (fieldName) {
            var filtered = false;
            if (fieldName == "Status") {
                fieldName = "EffectiveEndDate";
            }
            if (angular.isDefined(vm.filters)) {
                vm.filters.filters.forEach(function (filter) {
                    if (filter.field == fieldName)
                        filtered = true;
                });
            }
            return filtered;
        };

        //*******************Kendo row template functions****************************

        vm.dataObj = {
            value: "empty"
        };

        vm.isStatusActive = function (dataitem) {
            if (dataitem.EffectiveEndDate < vm.date) return true;
            return false;
        };

        vm.status = function (dataitem) {
            if (dataitem.EffectiveEndDate < vm.date) {
                return "Inactive";
            }
            return "Active";
        };

        vm.goToLAEdit = function (id) {
            // $state.go("private.transaction.loanapplication.edit",{Id:id,callbackState:$state.current.name});
        };

        //*******************KENDO*********************//
        var culture = kendo.culture();        

        culture.numberFormat.currency.symbol = "PKR. ";
        vm.formatDate = function (item) {
            return dateFormat(item.LoanApplicationDate);            
        };
        vm.formatId = function (item) {
            var id = item.LoanApplicationId;
            var template = '<md-button class="md-primary">' + id + '</md-button>';
            return template;
        };

        vm.gridColumns = [
            {
                field: "CreatorId",
                title: "Creator Id",
                search: true,
                hidden: true
            },
            // {
            //     field: "LoanApplicationId",
            //     title: "Loan App. Id",
            //     template: vm.formatId,
            //     type: "numeric",
            //     search: true
            // },
            {
                field: "LoanApplicationNumber",
                title: "Loan App. #",
                type: "string",
                // search: true
            },
            {
                field: "CustomerName",
                title: "Customer Name",
                template: "{{dataItem.CustomerName | defaultValue}}",
                type: "string",
                // search: true
            },
            {
                field: "ApprovedLoanAmount",
                title: "Apr. Loan Amount",
                type: "currency",
                filterable:false,
                template: " \{\{((dataItem.ApprovedLoanAmount <= 0 ? 'N/A' : dataItem.ApprovedLoanAmount) | tmxCurrency) | defaultValue:true\}\} ",
                // search: true,
            },
            {
                field: "Status",
                title: "Status",
                type: "string",
                // search: true,
            },
            {
                field: "LoanApplicationDate",
                title: "Created Date",
                template: vm.formatDate,                
                type:"date",
                filterable: {
                    // extra: true,    
                    ui:function(element){
                        element.kendoDatePicker({
                            format:'{0: dd/MM/yyyy}'                                              
                        })
                    },
                    operators:{
                        date:{
                            gte:"is equal to"                          
                        }
                    }              
                }                          
            }
        ];


        vm.mainGridOptions = {
            dataSource: {
                transport: {
                    read: function (o) {                        
                        if(o.data.filter)
                        {
                            setDateFilter(o);                         
                        }

                        vm.service.getByParams(o, true, action).then(function (response) {
                            o.success(response);

                        });
                    },

                    dataType: "json"
                },
                filter: JSON.parse(filter),
                schema: {
                    data: "data",
                    total: "Total"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
            },

            noRecords: {
                template: "<div class='no-record'>No loan application found for this user.</div>"
            },
            //data:vm.gridData,
            filterable: {
                extra: false,                              
            }, 
            scrollable: false,
            sortable: true,
            selectable: true,
            pageable: {
                refresh: true,
                pageSizes: true,
                pageSize: 10,
                buttonCount: 5
            },
            columns: vm.gridColumns
        };

        vm.mainGridOptions.change = function (e) {
            var selectedRows = this.select();
            var item = this.dataItem(selectedRows[0]);
            $scope.hide(item);

        };

        vm.container = {};
        $state.data = {
            grid: vm.container,
            info: false
        };

        function setDateFilter(o)
        {            
            var loanAppDate=o.data.filter.filters.find(x=>x.field=="LoanApplicationDate")                 
            if(angular.isDefined(loanAppDate))
            {
                var formattedDate=tmxUtility.formatDateSpecific(loanAppDate.value,"YYYY-MM-DD");
                var dateRange=angular.copy(loanAppDate);                
                o.data.filter.filters.find(x=>x.field=="LoanApplicationDate").value=formattedDate+"T00:00:00.00";                                
                //add filter for date range
                dateRange.value=formattedDate+"T23:59:59.59";
                dateRange.operator="lte";
                o.data.filter.filters.push(dateRange);               
            } 
        }


        $scope.hide = function (item) {
            $mdDialog.hide(item);
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.answer = function (answer) {
            $mdDialog.hide(answer);
        };
    }

})();